import config from "@/config";
import { authPatch } from "@/store/authStoreRequest";
import { getAccessToken } from "@/utils/accessToken";

import { type ExplicitUserConsent, getStoredExplicitConsent, subscribeToExplicitConsent } from "./consent";
import log from "./log";

async function persistExplicitConsent(consent: ExplicitUserConsent): Promise<void> {
  if (!getAccessToken()) {
    return;
  }

  const payload: Record<string, boolean> = {};
  if (consent.analyticsConsent !== undefined) {
    payload.analytics_consent = consent.analyticsConsent;
  }
  if (consent.marketingConsent !== undefined) {
    payload.marketing_consent = consent.marketingConsent;
  }

  if (Object.keys(payload).length === 0) {
    return;
  }

  try {
    await authPatch(`${config.backendURL}/user`, payload, {});
  } catch (error) {
    log.error("failed to persist user analytics and marketing consent", error);
  }
}

export function initUserConsentPersistence(): void {
  subscribeToExplicitConsent((consent) => {
    void persistExplicitConsent(consent);
  });
}

export async function syncStoredUserConsent(): Promise<void> {
  const consent = getStoredExplicitConsent();
  if (consent) {
    await persistExplicitConsent(consent);
  }
}
